import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import { SanityContentFloatImage } from '../../../../../graphql-types';
import * as styles from './floatImage.module.scss';
import { Caption } from '../../../../components/2.0version/caption/Caption';
import { RichText } from '../../../../components/2.0version/richText/RichText';

interface IFloatImageProps {
  data: SanityContentFloatImage;
}

export const FloatImage = ({ data }: IFloatImageProps) => {
  const { lang } = usePageContext();
  const { imageCaption } = data;
  const image = getImage(imageCaption?.image?.asset?.gatsbyImageData);
  const caption = imageCaption?._rawCaption?.[lang];

  return (
    <div className={`${styles.wrapper} ${data.order !== 'imageFirst' ? styles.reverse : ''}`}>
      {image && (
        <div key={`${data._key}-image`} className={styles.imageWrapper}>
          <GatsbyImage image={image} alt={imageCaption?.alt ?? ''} className={styles.image} />
          {caption && <Caption caption={caption} />}
        </div>
      )}
      <div key={`${data._key}-text`} className={styles.textWrapper}>
        <RichText value={data?._rawText?.text?.[lang]} />
      </div>
    </div>
  );
};
